"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _d3Delaunay = require("d3-delaunay");

var _d3Polygon = require("d3-polygon");

var _times = _interopRequireDefault(require("lodash/times"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _rejectUndefined = _interopRequireDefault(require("./rejectUndefined"));

var _defaultConstants = require("../defaultConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

const defaultOptions = {
  width: _defaultConstants.DEFAULT_WIDTH,
  height: _defaultConstants.DEFAULT_HEIGHT,
  maxIterations: 20,
  acceptableError: 1e-6,
  sorting: 'none',
  costFunctionYWeight: 1
};

const getInitialPoints = (numberOfPoints, maxWidth, maxHeight) => (0, _times.default)(numberOfPoints, () => [Math.random() * maxWidth, Math.random() * maxHeight]);
/**
 * This is a function that calculates a set of points evenly distributed in a defined space.
 * It uses the Lloyd's relaxation on a Voronoi diagram to distribute the points.
 * @param {number} numberOfCenters the number of points that need to be distributed in the space.
 * @param {object} [options={}] object with options
 * @param {number} [options.width=100] height of the space
 * @param {number} [options.height=100] height of the space
 * @param {number} [options.maxIterations=20] maximum number of iterations that the Lloyd's relaxation will run through.
 * More iterations mean a more optimal solution, however it can take a lot more time. Less iteration generate less optimal solutions.
 * @param {number} [options.acceptableError=1e-6] error that if achieved between iterations the relaxation process will stop, even if the iterations are not completed.
 * Bigger error with compute results faster.
 * @param {string} [options.sorting='none'] sorting applied to the generated points. 'none' no sorting applied. 'sortByX' sort ascending points using X.
 * 'sortByY' sort ascending points using Y. 'costFunction' sorts points using a cost function like `x + costFunctionYWeight * y`.
 * @param {number} [options.costFunctionYWeight=1] weight applied to Y in the sorting cost function if sorting='costFunction'.
 * @returns {Promise<Array<{x:number, y:number}>>} returns a Promise that when resolved returns an array with the points positions
 */


const getCenters =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(function* (numberOfCenters, options = defaultOptions) {
    const _defaultOptions$rejec = _objectSpread({}, defaultOptions, (0, _rejectUndefined.default)(options)),
          width = _defaultOptions$rejec.width,
          height = _defaultOptions$rejec.height,
          maxIterations = _defaultOptions$rejec.maxIterations,
          acceptableError = _defaultOptions$rejec.acceptableError,
          sorting = _defaultOptions$rejec.sorting,
          costFunctionYWeight = _defaultOptions$rejec.costFunctionYWeight;

    let centers = getInitialPoints(numberOfCenters, width, height);
    const error = {
      X: width,
      Y: height
    }; // initialize error with a big number
    // TODO --> Really? A for loop.... these days... OMG

    for (let i = 0; i < maxIterations && (error.X > acceptableError || error.Y > acceptableError); // A better approach would be to compare the squares of the errors
    i += 1) {
      error.X = 0;
      error.Y = 0;

      const delaunay = _d3Delaunay.Delaunay.from(centers);

      const voronoi = delaunay.voronoi([0, 0, width, height]);
      const cells = (0, _times.default)(numberOfCenters, index => voronoi.cellPolygon(index)); // eslint-disable-next-line no-loop-func

      const newCenters = cells.map((cell, index) => {
        const centroid = (0, _d3Polygon.polygonCentroid)(cell);
        const center = centers[index];
        const deltaX = centroid[0] - center[0];
        const deltaY = centroid[1] - center[1];
        error.X = error.X > Math.abs(deltaX) ? error.X : Math.abs(deltaX);
        error.Y = error.Y > Math.abs(deltaY) ? error.Y : Math.abs(deltaY); // error.Y = Math.abs(deltaY);

        const newCenterX = center[0] + deltaX;
        const newCenterY = center[1] + deltaY;
        return [newCenterX, newCenterY];
      });
      centers = newCenters;
    } // Organize each point in an object with x and y keys.


    centers = centers.map(value => ({
      x: value[0],
      y: value[1]
    }));

    switch (sorting) {
      case 'none':
        return centers;

      case 'sortByX':
        return (0, _sortBy.default)(centers, ['x']);

      case 'sortByY':
        return (0, _sortBy.default)(centers, ['y']);

      case 'costFunction':
        return (0, _sortBy.default)(centers, ({
          x,
          y
        }) => x + costFunctionYWeight * y);

      default:
        return centers;
    }
  });

  return function getCenters(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = getCenters;
exports.default = _default;